import { LookupItem } from "./lookup-item";

export class BusinessDetails {
  assetsRecent: string = '';
  assetsPrior: string = '';
  assetsTransferred: string = '';
  businessYears: LookupItem | null = null;
  investmentYears: LookupItem | null = null;
  businessHistory: string = '';
  hasPatents: string = '';
  patentDetails: string = '';
  hasTrademarks: string = '';
  trademarkDetails: string = '';
  hasJointVenture: string = '';
  joinVentureDetails: string = '';
  isExport: string = '';
  exportDetails: string = '';
  isGazelle: string = '';
  gazelleDetails: string = '';
  receivedFundingGrants: string = '';
  fundingGrantDetails: string = '';
  receivedFundingCapital: string = '';
  fundingCapitalDetails: string = '';
}
